import { Factory } from '../../services/Factory';

namespace app.directives.reporting.tracking {

  export interface IButtonTrackerScope extends angular.IScope {
  }

  export interface IButtonTrackerAttributes extends angular.IAttributes {
  }

  export class ButtonTracker implements angular.IDirective {
    public restrict = 'E';
    public scope = false;
    public replace = false;
    public priority = 100;
    public link: (scope: IButtonTrackerScope, element: angular.IAugmentedJQuery, attrs: IButtonTrackerAttributes) => void;

    constructor(trackService: app.services.auditing.TrackService) {
      this.link = (scope: IButtonTrackerScope, element: angular.IAugmentedJQuery, attrs: IButtonTrackerAttributes) => {
        let trackString = "";

        attrs.$observe('track', (value: string) => value && (trackString = value));

        element.bind('click', () => trackService.ClickHandler(trackString, element));
      }
    };
  }

  frontendApp.directive("button", ["TrackService", Factory.Create(ButtonTracker)]);
}
